/*
 *  ping.js - v0.2.2
 *  Ping Utilities in Javascript
 *  http://github.com/alfg/ping.js
 *
 *  Made by Alfred Gutierrez
 *  Under MIT License
 */
/**
 * Creates a Ping instance.
 * @returns {Ping}
 * @constructor
 */
export const Ping = function (opt) {
  this.opt = opt || {};
  this.favicon = this.opt.favicon || "/favicon.ico";
  this.timeout = this.opt.timeout || 0;
  this.logError = this.opt.logError || false;
};

/**
 * Pings source and triggers a callback when completed.
 * @param source Source of the website or server, including protocol and port.
 * @param callback Callback function to trigger when completed. Returns error and ping value.
 * @param timeout Optional number of milliseconds to wait before aborting.
 */
Ping.prototype.ping = function (source, callback) {
  var self = this;
  self.wasSuccess = false;
  self.img = new Image();
  self.img.onload = onload;
  self.img.onerror = onerror;

  var timer;
  var start = new Date();

  function onload(e) {
    self.wasSuccess = true;
    pingCheck.call(self, e);
  }

  function onerror(e) {
    self.wasSuccess = false;
    pingCheck.call(self, e);
  }

  if (self.timeout) {
    timer = setTimeout(function () {
      pingCheck.call(self, undefined);
    }, self.timeout);
  }

  /**
   * Times ping and triggers callback.
   */
  function pingCheck() {
    if (timer) {
      clearTimeout(timer);
    }
    var pong = new Date() - start;

    if (typeof callback === "function") {
      // When operating in timeout mode, the timeout callback doesn't pass [event] as e.
      // Notice [this] instead of [self], since .call() was used with context
      if (!this.wasSuccess) {
        if (self.logError) {
          console.error("error loading resource");
        }
        return callback("error", pong);
      }
      return callback(null, pong);
    }
  }

  self.img.src = source + self.favicon + "?" + +new Date(); // Trigger image load with cache buster
};

if (typeof exports !== "undefined") {
  if (typeof module !== "undefined" && module.exports) {
    module.exports = Ping;
  }
} else {
  window.Ping = Ping;
}
